import withTranslations from "../../../../../../hocs/withTranslations";
import { compose } from "redux";
import React from "react";
import useIsDesktop from "../../../hooks/useIsDesktop";
import classNames from "classnames";

const SelectedPlanName = ({ name, translate }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={"flex gap-4 align-center"}>
      <span className={"text-xs text-black opacity-65"}>
        {translate("plans_payment-bar_current-plan")}
      </span>
      <strong
        className={classNames("text-black font-bold z-10", {
          "text-2xl": isDesktop,
          "text-xl": !isDesktop
        })}
      >
        {name}
      </strong>
    </div>
  );
};

export default compose(withTranslations)(SelectedPlanName);
